import { Button, Tooltip } from "@nextui-org/react";
import { useClipboard } from "@nextui-org/use-clipboard";
import { Check, Copy } from "lucide-react";

interface CopyButtonProps {
  textToCopy: string;
  disabled?: boolean;
}

const CopyButton = ({ textToCopy, disabled = false }: CopyButtonProps) => {
  const { copy, copied } = useClipboard();

  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || !textToCopy) return;
    copy(textToCopy);
  };

  if (disabled) return null;

  return (
    <Tooltip
      content={copied ? "Copied" : "Copy"}
      placement="top"
      delay={500}
      closeDelay={0}
      classNames={{
        base: "before:bg-black/80",
        content: "py-1 px-2 bg-black/80 backdrop-blur-sm text-white text-xs rounded-lg",
      }}
    >
      <Button
        isIconOnly
        radius="sm"
        size="sm"
        variant="light"
        onPress={() => copy(textToCopy)}
        onClick={handleCopy}
        className="min-w-[20px] w-[20px] h-[20px] p-[2px] rounded opacity-0 group-hover:opacity-100 transition-opacity bg-transparent hover:bg-transparent"
      >
        {copied ? (
          <Check size={16} className="text-green-500" />
        ) : (
          <Copy size={16} className="text-[#71717A]" />
        )}
      </Button>
    </Tooltip>
  );
};

export default CopyButton;

